// src/components/FloatingContactButtons.jsx
import React from "react";
import { FaEnvelope, FaPhoneAlt, FaWhatsapp } from "react-icons/fa";
import { getLocalStorageItem } from "../Utils";

const FloatingContactButtons = () => {
  const iconStyle = "text-white text-xl";
  const btnStyle = "flex items-center justify-center w-12 h-12 rounded-full shadow-lg mb-3";
  const detail = getLocalStorageItem("detail");

  return (
    <div className="fixed bottom-6 right-6 flex flex-col items-end z-50">
      {/* WhatsApp */}
      {getLocalStorageItem("detail")?.whatsapp_support_no != null &&
        <a
          href={`https://wa.me/${detail?.whatsapp_support_no}`}
          target="_blank"
          rel="noopener noreferrer"
          className={`${btnStyle} bg-green-500 hover:bg-green-600`}
        >
          <FaWhatsapp className={iconStyle} />
        </a>


      }

      {/* Call */}
      <a
        href={`tel:${detail?.support_no}`} className={`${btnStyle} bg-blue-500 hover:bg-blue-600`}>
        <FaPhoneAlt className={iconStyle} />
      </a>

      {/* Email */}
      <a
        href={`mailto:${detail?.support_email}`}
        className={`${btnStyle} bg-red-500 hover:bg-red-600`}>
        <FaEnvelope className={iconStyle} />
      </a>
    </div>
  );
};

export default FloatingContactButtons;
